<script setup lang="ts">
import { useTemplateRef } from "vue";

import { cardActions } from "@/action/cardActions";

import ActionMenuDropdown from "./ActionMenuDropdown.vue";
import MoreMenuPanel from "./internal/MoreMenuPanel.vue";

const flyoutHost = useTemplateRef<HTMLElement>("flyoutHost");
</script>

<template>
  <!-- first in the fragment so the button stays :last-child and keeps no right border -->
  <div ref="flyoutHost" class="flyout-host" />
  <ActionMenuDropdown :action="cardActions.more" max-height="content" aria-haspopup="menu">
    <MoreMenuPanel :host="flyoutHost">
      <slot />
    </MoreMenuPanel>
  </ActionMenuDropdown>
</template>

<style lang="scss" scoped>
.flyout-host {
  display: contents;
}
</style>
